// agent cold transfers to another agent.
export const TRANSFER_TYPE_COLD = 1
// agent merges in another agent and remains on the line.
export const TRANSFER_TYPE_CONF = 2
// agent merges in another agent and leaves.
export const TRANSFER_TYPE_WARM = 3
